import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/configs/supabase/config";

export const Route = createFileRoute("/_protected/$organizationId")({
  beforeLoad: async ({ context, params }) => {
    const { userId } = context as { userId: string };
    const { organizationId } = params;

    const sb_FromOrganizationMembers_Select = await supabase
      .from("organization_members")
      .select("organization_id")
      .eq("user_id", userId)
      .eq("organization_id", organizationId)
      .eq("status", "active")
      .single();

    if (sb_FromOrganizationMembers_Select.error || !sb_FromOrganizationMembers_Select.data) {
      throw redirect({ to: "/", search: { denied: "org" } });
    }

    return { organizationId };
  },
  component: () => <Outlet />,
});
